import FlickeringLightSource from "./FlickeringLightSource";
import LightSource from "./LightSource";
import LightSourceCache from "./LightSourceCache";

export default class FlickeringLightSourceCache extends LightSourceCache {
    constructor() {
        super();
    }

    /**
     * @override
     * @returns {LightSource}
     */
    createInstance() {
        return new FlickeringLightSource();
    }

}